
import { computed, defineComponent, PropType } from 'vue'

interface CargoStatuses {
    [key: number]: string
}

const CARGO_STATUSES: CargoStatuses = {
    1: 'CargoStatus--red',
    2: 'CargoStatus--yellow',
    3: 'CargoStatus--blue',
    4: 'CargoStatus--green',
}

export default defineComponent({
    props: {
        status: {
            type: Object as PropType<{ title: string; id: number }>,
            required: true,
        },
    },
    setup(props) {
        const cargoStatusClasses = computed(() => CARGO_STATUSES[props.status.id])

        const iconClass = computed(() => {
            if (props.status.id === 1) return 'fas fa-times-circle'
            return 'fas fa-check-circle'
        })

        return {
            cargoStatusClasses,
            iconClass,
        }
    },
})
